import { Icon } from "./Icon.tsx";

/** "Add Weir" tool icon — AddConduitIcon.tsx's own two-nodes-joined-by-a-pipe glyph, with a small crossbar (the crest) at the midpoint marking it as a weir rather than a plain conduit. */
export function AddWeirIcon() {
  return (
    <Icon>
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      <path d="M7 17.5L17 6.5" />
      <path d="M9.5 14.5h5" />
    </Icon>
  );
}
